import { PrometheusTheme } from '@prometheus/types'

const STORAGE_KEY = 'prometheus-theme'
export const DEFAULT_THEME: PrometheusTheme = 'dark'

function isTheme(value: unknown): value is PrometheusTheme {
  return value === 'light' || value === 'dark'
}

// Last-known theme, cached locally so we can paint the right palette on first
// frame — before auth/Firestore resolves — and avoid a flash of the wrong theme.
export function getStoredTheme(): PrometheusTheme {
  if (typeof window === 'undefined') return DEFAULT_THEME
  return isTheme(window.localStorage.getItem(STORAGE_KEY)) ? (window.localStorage.getItem(STORAGE_KEY) as PrometheusTheme) : DEFAULT_THEME
}

// Sets the attribute the SCSS keys off (:root[data-theme="dark"]) and caches it.
export function applyTheme(theme: PrometheusTheme): void {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', theme)
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // ignore storage failures (private mode, etc.)
  }
}
